import React, { useEffect, useState } from "react";
import ModalWrapper from "./Modal";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import "./UpdateButton.scss";
import useUpdateAvailable from "common/useUpdateAvailable";

const UpdateButton: React.FC = () => {
    const updateAvailable = useUpdateAvailable();

    useEffect(() => {
        // the following browser APIs have been available in all browsers since Jan 2026, but are not defined in our current version of TypeScript
        type NavigationEvent = {
            navigationType: string;
            destination: { url: string };
        };
        type NavigationEventListener = (event: NavigationEvent) => void;
        type Navigation = {
            addEventListener(type: 'navigate', listener: NavigationEventListener): void;
            removeEventListener(type: 'navigate', listener: NavigationEventListener): void;
        }
        const navigation = (globalThis as unknown as { navigation: Navigation }).navigation;

        // intercept navigation event and force full non-SPA nav if an update is available
        // it'd be better to use a React Router API to intercept its navigation,
        // but our current version (5) doesn't provide anything suitable
        // useBlocker is worth exploring when we upgrade
        const listener: NavigationEventListener = (event) => {
            if (event.navigationType === 'push' && updateAvailable) {
                location.assign(event.destination.url);
            }
        }
        navigation.addEventListener('navigate', listener);
        return () => navigation.removeEventListener('navigate', listener);
    }, [updateAvailable])

    const [modalDismissed, setModalDismissed] = useState(false);
    const dismissModal = () => setModalDismissed(true);

    if (!updateAvailable) return null;

    return (
        <>
            {modalDismissed ? null : (
                <ModalWrapper
                    title="Update Available"
                    advanceButtonText="Refresh Now"
                    onAdvance={() => globalThis.location.reload()}
                    cancelButtonText="Refresh Later"
                    onCancel={dismissModal}
                >
                    <p>A new version of StoneX Hedge is available. Please refresh and update at your earliest convenience.</p>
                </ModalWrapper>
            )}
            <OverlayTrigger overlay={<Tooltip id="update-button-tooltip">Refresh and Update</Tooltip>}>
                <button className="link-button update-button" onClick={() => globalThis.location.reload()} type="button">
                    <i className="material-icons" data-testid="update-icon">upgrade</i>
                    <span className="dot" />
                    <span className="dot ping" />
                </button>
            </OverlayTrigger>
        </>
    );
}

export default UpdateButton;
